/*
| ----------------------------------------------------------------------------------
| TABLE OF CONTENT
| ----------------------------------------------------------------------------------
-Preloader
-Scroll Animation
-ToTop
-Parallax(Stellar)
-View catalog
-Animated Entrances
-Chars Start
-Video player
-Loader blocks
-Accordion
-Tooltip
-Zoom Images
-Isotope filter
-Select customization
-Datepicker
-Enumerator
-Price range
-Main slider
-Thumbnail sliders
-OWL Sliders
-Nouislider
*/



jQuery(document).ready(function($) {

    "use strict";


/* Safari */
var is_safari = navigator.userAgent.indexOf("Safari") > -1;
if(is_safari) {
  $('body').addClass('safari');
}


/////////////////////////////////////////////////////////////////
// Preloader
/////////////////////////////////////////////////////////////////

var $preloader = $('#page-preloader'),
$spinner   = $preloader.find('.spinner-loader');
$spinner.fadeOut();
$preloader.delay(50).fadeOut('slow');


/////////////////////////////////////
//  Scroll Animation
/////////////////////////////////////


if ($('.scrollreveal').length > 0) {
    window.sr = ScrollReveal({
        reset:true,
        duration: 1000,
        delay: 200
    });

    sr.reveal('.scrollreveal');
  }


//////////////////////////////
// ToTop
//////////////////////////////




    
    $('#toTop').on( 'click', function() {
     $('body,html').animate({scrollTop:0},800);
  });
    
    



//////////////////////////////
// Parallax(Stellar)
//////////////////////////////

if ($('.stellar').length > 0) {
    $.stellar({
        responsive: true
    });
}


////////////////////////////////////////////
// View catalog
///////////////////////////////////////////


if ($('.btns-switch').length > 0) {
  $('.btns-switch__item').on( 'click', function() {
    $('.btns-switch').find('.active').removeClass('active');
    $( this ).addClass('active');
  });

  $('.js-view-th').on( 'click', function() {
    $('.list-goods').addClass('list-goods_th');
  });

  $('.js-view-list').on( 'click', function() {
    $('.list-goods').removeClass('list-goods_th');
  });
}

/////////////////////////////////////
//  Chars Start
/////////////////////////////////////


if ($('body').length) {
    $(window).on('scroll', function() {
        var winH = $(window).scrollTop();

        $('.js-progress-list').waypoint(function() {
            $('.js-chart').each(function() {
                CharsStart();
            });
        }, {
            offset: '80%'
        });
    });
}


function CharsStart() {

    $('.js-chart').easyPieChart({
        barColor: false,
        trackColor: false,
        scaleColor: false,
        scaleLength: false,
        lineCap: false,
        lineWidth: false,
        size: false,
        animate: 5000,

        onStep: function(from, to, percent) {
            $(this.el).find('.js-percent').text(Math.round(percent));
        }
    });
}



/////////////////////////////////////
//  Video player
/////////////////////////////////////


if ($('.player').length > 0) {
  $(".player").flowplayer();
}



/////////////////////////////////////
//  Loader blocks
/////////////////////////////////////


    $( ".js-scroll-next" ).on( "click", function() {

        var hiddenContent =  $( ".js-scroll-next + .js-scroll-content") ;

        $(".js-scroll-next").hide() ;
        hiddenContent.show() ;
        hiddenContent.addClass("animated");
        hiddenContent.addClass("animation-done");
        hiddenContent.addClass("bounceInUp");

    });



/////////////////////////////////////////////////////////////////
// Accordion
/////////////////////////////////////////////////////////////////

    $(".btn-collapse").on('click', function () {
            $(this).parents('.panel-group').children('.panel').removeClass('panel-default');
            $(this).parents('.panel').addClass('panel-default');
            if ($(this).is(".collapsed")) {
                $('.panel-title').removeClass('panel-passive');
            }
            else {$(this).next().toggleClass('panel-passive');
        };
    });


/////////////////////////////////////
//  Tooltip
/////////////////////////////////////


    $('.link-tooltip-1').tooltip({
    template: '<div class="tooltip tooltip-1" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  });
    $('.link-tooltip-2').tooltip({
    template: '<div class="tooltip tooltip-2" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  });





/////////////////////////////////////
//  Zoom Images
/////////////////////////////////////



  if ($('.js-zoom-gallery').length > 0) {
      $('.js-zoom-gallery').each(function() { // the containers for all your galleries
          $(this).magnificPopup({
              delegate: '.js-zoom-gallery__item', // the selector for gallery item
              type: 'image',
              gallery: {
                enabled:true
              },
        mainClass: 'mfp-with-zoom', // this class is for CSS animation below

        zoom: {
          enabled: true, // By default it's false, so don't forget to enable it

          duration: 300, // duration of the effect, in milliseconds
          easing: 'ease-in-out', // CSS transition easing function

          // The "opener" function should return the element from which popup will be zoomed in
          // and to which popup will be scaled down
          // By defailt it looks for an image tag:
          opener: function(openerElement) {
            // openerElement is the element on which popup was initialized, in this case its <a> tag
            // you don't need to add "opener" option if this code matches your needs, it's defailt one.
            return openerElement.is('img') ? openerElement : openerElement.find('img');
          }
        }
          });
      });
    }


  if ($('.js-zoom-images').length > 0) {
      $('.js-zoom-images').magnificPopup({
        type: 'image',
        mainClass: 'mfp-with-zoom', // this class is for CSS animation below

        zoom: {
          enabled: true, // By default it's false, so don't forget to enable it

          duration: 300, // duration of the effect, in milliseconds
          easing: 'ease-in-out', // CSS transition easing function

          // The "opener" function should return the element from which popup will be zoomed in
          // and to which popup will be scaled down
          // By defailt it looks for an image tag:
          opener: function(openerElement) {
            // openerElement is the element on which popup was initialized, in this case its <a> tag
            // you don't need to add "opener" option if this code matches your needs, it's defailt one.
            return openerElement.is('img') ? openerElement : openerElement.find('img');
          }
        }
      });

    }



////////////////////////////////////////////
// ISOTOPE FILTER
///////////////////////////////////////////


  if ($('.b-isotope').length > 0) {

    var $container = $('.b-isotope-grid');

    // init Isotope
    var $grid = $('.grid').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer'
      }
    });
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });

    // filter items when filter link is clicked
    $('.b-isotope-filter a').on( 'click', function() {
        var selector = $(this).attr('data-filter');
        $container.isotope({
            filter: selector
        });
        return false;
    });

    $('.b-isotope-filter a').on( 'click', function() {
      $('.b-isotope-filter').find('.current').removeClass('current');
      $( this ).parent().addClass('current');
    });
  }




/////////////////////////////////////
// Select customization
/////////////////////////////////////

if ($('.selectpicker').length > 0) {

  $('.selectpicker').selectpicker({
    style: 'ui-select',
    styleBase: '',
    size: "false"
  });
}



/////////////////////////////////////
// Datepicker
/////////////////////////////////////

if ($('#datetimepicker').length > 0) {
  $('#datetimepicker').datetimepicker({
    timepicker:false,
    format:'d/m/Y',
    formatDate:'Y/m/d'
  });
}
if ($('#datepicker').length > 0) {
  $('#datepicker').datetimepicker({
    timepicker:false,
    format:'d/m/Y',
    formatDate:'Y/m/d'
  });
}
if ($('#offdatepicker').length > 0) {
  $('#offdatepicker').datetimepicker({
    timepicker:false,
    format:'d/m/Y',
    formatDate:'Y/m/d'
  });
}

/////////////////////////////////////
// Enumerator
/////////////////////////////////////

if ($('.enumerator').length > 0) {
    $(".js-minus_btn").on('click', function() {
        var inputEl = jQuery(this).parent().children().next();
        var qty = inputEl.val();
        if (jQuery(this).parent().hasClass("js-minus_btn"))
            qty++;
        else
            qty--;
        if (qty < 0)
            qty = 0;
        inputEl.val(qty);
    });


    $(".js-plus_btn").on('click', function() {
        var inputEl = jQuery(this).parent().children().next();
        var qty = inputEl.val();
        if (jQuery(this).hasClass("js-plus_btn"))
            qty++;
        else
            qty--;
        if (qty < 0)
            qty = 0;
        inputEl.val(qty);
    });
  }



/////////////////////////////////////////////////////////////////
//PRICE RANGE
/////////////////////////////////////////////////////////////////


    if ($('.js-slider-price').length > 0) {


        $(".js-slider-price").noUiSlider({
            start: [ 1000, 3000 ],
            step: 10,
            connect: true,
            range: {
                'min': 0,
                'max': 5000
            },

            // Full number format support.
            format: wNumb({
                decimals: 0,
                prefix: '$'
            })
        });

      // Reading/writing + validation from an input? One line.
      $('.js-slider-price').Link('lower').to($('.js-slider-price_min'));

      // Write to a span? One line.
      $('.js-slider-price').Link('upper').to($('.js-slider-price_max'));

    }


////////////////////////////////////////////
// Main slider
///////////////////////////////////////////


    if ($('#main-slider').length > 0) {
        console.log('Main slider exist');

        var sliderWidth = $("#main-slider").data("slider-width");
        var sliderHeigth = $("#main-slider").data("slider-height");
        var sliderArrows = $("#main-slider").data("slider-arrows");
        var sliderButtons = $("#main-slider").data("slider-buttons");

        $( '#main-slider' ).sliderPro({
            width:  sliderWidth,
            height: sliderHeigth,
            arrows: sliderArrows,
            buttons: sliderButtons,
            fade: true,
            fullScreen: true,
            touchSwipe: false,
            autoplay: true,
            autoplayOnHover: 'none'
        });
    }


////////////////////////////////////////////
// THUMBNAIL SLIDERS
///////////////////////////////////////////


  if ($('#slider-thumbnail').length > 0) {

    $( '#slider-thumbnail' ).sliderPro({
      width: 682,
      height: 505,
      orientation: 'vertical',
      loop: false,
      arrows: false,
      buttons: false,
      thumbnailsPosition: 'left',
      thumbnailPointer: true,
      thumbnailWidth: 458,
      thumbnailHeight: 101,
      thumbnailArrows: true,
      autoplay: true,
      breakpoints: {
        800: {
          thumbnailsPosition: 'bottom',
          thumbnailWidth: 270,
          thumbnailHeight: 100
        },
        500: {
          thumbnailsPosition: 'bottom',
          thumbnailWidth: 200
        }
      }
    });
  }


  if ($('#slider-car-details').length > 0) {

    $( '#slider-car-details' ).sliderPro({
      width: 750,
      height: 400,
      arrows: false,
      buttons: true,
      waitForLayers: true,
      thumbnailWidth: 140,
      thumbnailHeight: 85,
      thumbnailPointer: true,
      autoplay: true,
      autoScaleLayers: false,
      breakpoints: {
        500: {
          thumbnailWidth: 120,
          thumbnailHeight: 70
        }
      }
    });
  }



/////////////////////////////////////////////////////////////////
// OWL Sliders
/////////////////////////////////////////////////////////////////

    var Core = {

        initialized: false,

        initialize: function() {

                if (this.initialized) return;
                this.initialized = true;

                this.build();

        },

        build: function() {

        // Owl Carousel

            this.initOwlCarousel();
        },
        initOwlCarousel: function(options) {

            $(".enable-owl-carousel").each(function(i) {
                var $owl = $(this);

                var itemsData = $owl.data('items');
                var navigationData = $owl.data('navigation');
                var paginationData = $owl.data('pagination');
                var marginData = $owl.data('margin');
                var singleItemData = $owl.data('single-item');
                var autoPlayData = $owl.data('auto-play');
                var mainSliderData = $owl.data('main-text-animation');
                var afterInitDelay = $owl.data('after-init-delay');
                var stopOnHoverData = $owl.data('stop-on-hover');
                var min480 = $owl.data('min480');
                var min768 = $owl.data('min768');
                var min992 = $owl.data('min992');
                var min1200 = $owl.data('min1200');

                $owl.owlCarousel({
                    responsiveClass:true,
                    nav : navigationData,
                    dots: paginationData,
                    margin : marginData,
                    autoplayTimeout : autoPlayData,
                    autoplayHoverPause: stopOnHoverData,
                    navText : ["<i></i>","<i></i>"],
                    items: itemsData,
                    loop: true,
                    autoplay: true,
                    responsive: {
                      0: {items: 1},
                      768: {items: min768},
                      1024: {items: min992},
                      1200: {items: min1200}
                    },
                    afterInit: function(elem){
                                if(mainSliderData){
                                        setTimeout(function(){
                                                $('.main-slider_zoomIn').css('visibility','visible').removeClass('zoomIn').addClass('zoomIn');
                                                $('.main-slider_fadeInLeft').css('visibility','visible').removeClass('fadeInLeft').addClass('fadeInLeft');
                                                $('.main-slider_fadeInLeftBig').css('visibility','visible').removeClass('fadeInLeftBig').addClass('fadeInLeftBig');
                                                $('.main-slider_fadeInRightBig').css('visibility','visible').removeClass('fadeInRightBig').addClass('fadeInRightBig');
                                        }, afterInitDelay);
                                    }
                    },
                    beforeMove: function(elem){
                        if(mainSliderData){
                                $('.main-slider_zoomIn').css('visibility','hidden').removeClass('zoomIn');
                                $('.main-slider_slideInUp').css('visibility','hidden').removeClass('slideInUp');
                                $('.main-slider_fadeInLeft').css('visibility','hidden').removeClass('fadeInLeft');
                                $('.main-slider_fadeInRight').css('visibility','hidden').removeClass('fadeInRight');
                                $('.main-slider_fadeInLeftBig').css('visibility','hidden').removeClass('fadeInLeftBig');
                                $('.main-slider_fadeInRightBig').css('visibility','hidden').removeClass('fadeInRightBig');
                        }
                    },
                    afterMove: sliderContentAnimate,
                    afterUpdate: sliderContentAnimate,
                });
            });

            function sliderContentAnimate(elem){
                var $elem = elem;
                var afterMoveDelay = $elem.data('after-move-delay');
                var mainSliderData = $elem.data('main-text-animation');
                if(mainSliderData){
                    setTimeout(function(){
                        $('.main-slider_zoomIn').css('visibility','visible').addClass('zoomIn');
                        $('.main-slider_slideInUp').css('visibility','visible').addClass('slideInUp');
                        $('.main-slider_fadeInLeft').css('visibility','visible').addClass('fadeInLeft');
                        $('.main-slider_fadeInRight').css('visibility','visible').addClass('fadeInRight');
                        $('.main-slider_fadeInLeftBig').css('visibility','visible').addClass('fadeInLeftBig');
                        $('.main-slider_fadeInRightBig').css('visibility','visible').addClass('fadeInRightBig');
                    }, afterMoveDelay);
                }
            }
        },

    };

    Core.initialize();


  /////////////////////////////////////////////////////////////////
  // Nouislider
  /////////////////////////////////////////////////////////////////
  if ($('#slider-price').length > 0) {
    var slider = document.getElementById('slider-price');

    noUiSlider.create(slider, {
      start: [ 5000, 15000 ],
      range: {
        'min': [0],
        'max': [20000]
      },
      step: 100,
      connect: true,
      format: wNumb({
        decimals: 0
      }),
    });
    var snapValues = [
      document.getElementById('slider-snap-value-lower'),
      document.getElementById('slider-snap-value-upper')
    ];

    slider.noUiSlider.on('update', function( values, handle ) {
      snapValues[handle].innerHTML = values[handle];
    });
  }

  var $document = $(document),
  $element = $('header'),
  className = 'sticky';

  $document.scroll(function() {
    $element.toggleClass(className, $document.scrollTop() >= 1);
  });

  ///// fpl-imgwaccordion /////
  // $('.fpl-imgwaccordion .panel').hover(
  //   function(){
  //     $(this).addClass('panel-default');
  //     $(this).find('.collapse').addClass('show');

  //   }, function(){
  //     $(this).removeClass('panel-default');
  //     $(this).find('.collapse').removeClass('show');
  //   }
  // );

  $('.fpl-imgwaccordion .col-lg-6 > .img-0').css('display','block');

  $('.fpl-imgwaccordion .panel').click(function(){
    var index = $('.fpl-imgwaccordion .panel').index(this);
    $('.fpl-imgwaccordion .col-lg-6 > img').each(function(){
      $(this).css('display','none');
    });
    $('.fpl-imgwaccordion .col-lg-6 > img.img-'+index).css('display','block');
  });

  ///// fpl-slider /////
  $('.sp-buttons').addClass('container');

  ///// fpl-metier /////
  $('.fpl-metier a').hover(function() {
    var id = $(this).attr("href").substring(1, 2);
    $('.lines span').removeClass('active');
    $('.lines span#item-'+id).addClass('active');
    $(this).tab('show');
  });

  ///// mobile menu /////
  $('button.menu-mobile-button').click(function() {
    $('.header-navibox-2').toggle();
  });

  ///// Header sticky SCROLL /////

  $(document).scroll(function() {

    var $document = $(document),
    $element = $('.header-topbarbox-1.logo-top-block'),
    className = 'hasScrolled';

    if ($document.scrollTop() >= 1) {
      $element.addClass('remove');
    } else {
      $element.removeClass('remove');
    }
  });

  ///// Bouton de contact nos centres /////
  $('a.centre-contact-btn').click(function() {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $("#contact").offset().top - 150
    }, 2000);
  });

  ///// Lire + floatblock /////
  $('div.short-yes:not(.active) + button').click(function(){
    $(".short-yes").toggleClass("active");
  });

  ///// Galerie /////
  $('.gallery a').simpleLightbox();

  ///// Share Facebook /////
  var url = window.location.href;

  $('#fb-share-button').on('click', function() {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url,
          'facebook-share-dialog',
          'width=800,height=600'
      );
      return false;
  });
  
  //// Accordeon page Services ////
  $('.fpl-imgwaccordion .panel-group .panel').hover(
    function () {
      $('.fpl-imgwaccordion .panel-default').removeClass('panel-default');
      $(this).find('a.btn-collapse').trigger('click');
      $(this).find('.panel-collapse').addClass('collapse show');
    },
    function () {
      $('.fpl-imgwaccordion .panel-default').removeClass('panel-default');
      $(this).find('.panel-collapse.collapse.show').removeClass('show');
    }
  );

  $('.fpl-team li').hover(
    function () {
      $('.fpl-team .tab-pane.show').removeClass('active show');
      $(this).find('a').trigger('click');
    }
  );

  ///// Ancres internes /////
  $(document).on('click', 'body.services .fpl-services a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 150
    }, 1000);
  });
  
  $('.b-filter-type__label').on('click', function () {
      // $.ajax({
      //    url: "/occasions/?type=" + $(this).prev().attr('id')
      // }).done(function (html) {
      //     $('#liste-occasion-ajax').html($(html).find('#liste-occasion-ajax'))
      // });
      window.location.href = "/neufs-occasions/?type=" + $(this).prev().attr('id');
  });

  ///// Ancres nons centres /////
  $(document).on('click', 'body.nos-centres .fpl-centre-list a[href^="#"]', function (event) {

    setTimeout(scrollto, 250);

    var href =  $(this).attr('href');

    function scrollto() {  
      var scroll = $(href).offset().top - 300;

      event.preventDefault();
      $('html, body').animate({
          scrollTop: scroll
      }, 1000);
    }

    var btn = $(this).attr('href');
    var e = $(btn).closest('.panel');

    $('.panel-default').removeClass('panel-default');
    $(e).addClass('panel-default');

  });

  $(document).on('click', 'body.nos-centres .panel-group a.btn-collapse[href^="#"]', function () {
    setTimeout(scrollto, 250);

    var href =  $(this).attr('href');

    function scrollto() {  
      var scroll = $(href).offset().top - 300;

      $('html, body').animate({
          scrollTop: scroll
      }, 500);
    }
  });

  /* VO Slide */
  $(document).ready(function() {
    var bigimage = $("#big");
    var thumbs = $("#thumbs");
      //var totalslides = 10;
      var syncedSecondary = true;

      bigimage
      .owlCarousel({
        items: 1,
        //slideSpeed: 2000,
        nav: true,
        //autoplay: true,
        dots: false,
        //loop: true,
        //responsiveRefreshRate: 200,
        navText: [
        '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
        '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
        ]
      })
      .on("changed.owl.carousel", syncPosition);

      thumbs
      .on("initialized.owl.carousel", function() {
        thumbs
        .find(".owl-item")
        .eq(0)
        .addClass("current");
      })
      .owlCarousel({
        items: 4,
        dots: true,
        nav: true,
        navText: [
        '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
        '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
        ],
        smartSpeed: 200,
        slideSpeed: 500,
        slideBy: 4,
        responsiveRefreshRate: 100
      })
      .on("changed.owl.carousel", syncPosition2);

      function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
          current = count;
        }
        if (current > count) {
          current = 0;
        }
        //to this
        thumbs
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
        .find(".owl-item.active")
        .first()
        .index();
        var end = thumbs
        .find(".owl-item.active")
        .last()
        .index();

        if (current > end) {
          thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
          thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        bigimage.data("owl.carousel").to(number, 100, true);
      }
    }

    thumbs.on("click", ".owl-item", function(e) {
      e.preventDefault();
      var number = $(this).index();
      bigimage.data("owl.carousel").to(number, 300, true);
    });
  });

  $('.dl_pdf').on('click', function() {
    var print = document.getElementById('print-page');
    var opt = {
      margin:       [5, 8],
      filename:     'Vehicule.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2, width: 1550 },
      jsPDF:        { orientation: 'landscape' }
    };

    $("#big").data("owl.carousel").to(0, 300, true);

    html2pdf(print, opt);
  });

});